module.exports = __webpack_public_path__ + "static/img/community07.63d30b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community07.jpg
// module id = Hhnv
// module chunks = 0